import { render } from "./CardSettingOverlay.vue?vue&type=template&id=0653655a&scoped=true"
import script from "./CardSettingOverlay.vue?vue&type=script&lang=js"
export * from "./CardSettingOverlay.vue?vue&type=script&lang=js"

import "./CardSettingOverlay.vue?vue&type=style&index=0&id=0653655a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0653655a"]])

export default __exports__